import { child, get, set } from "firebase/database";
import { Timestamp, doc, setDoc } from "firebase/firestore";
import { AuthCubit } from "../../../blocs/auth/AuthBloc";
import { firestore } from "../../../core/utils/firebase";
import { rowDataObject } from "../../core/DataTable/DataTableInterfaces";
import { FirebaseDataTableRepository } from "../../core/DataTable/FirebaseDataTableRepository";

export class BlogsFirebaseDataTableRepository extends FirebaseDataTableRepository {
    private authCubit = AuthCubit.getInstance();
    add: (data: any) => Promise<Object> = async (data: any) => {
        const docRef = doc(firestore, `${this.dataCollection.id}/${(data as any).id}`);
        let newData = rowDataObject<any>(data);
        newData.id = docRef.id;
        newData.userID = this.authCubit.state.user!.id;
        newData.user = this.authCubit.state.user!;
        delete newData.user.role;
        delete newData.user.creationDate;
        this.columns.filter(col => [
            'date',
            'datetime',
            'image',
            'file',
            'hashtags',
        ].includes(col.type)).forEach(async col => {
            if ((col.type === 'date' || col.type === 'datetime') && newData[col.field]) {
                newData[col.field] = Timestamp.fromDate(new Date(newData[col.field]));
            } else if (col.type === 'hashtags') {
                newData[col.field] = [...new Set((newData[col.field] as string).split(",").map(hashtag => hashtag.trim()))];
                const thisDataHashTagsRef = child(this.realDbRef, col.field);
                let thisDataHashTags: Set<string>;
                try {
                    const thisDataHashTagsSnap = await get(thisDataHashTagsRef);
                    thisDataHashTags = thisDataHashTagsSnap.exists() ? new Set([...thisDataHashTagsSnap.val()]) : new Set();
                } catch (error) {
                    thisDataHashTags = new Set();
                }
                for (const hashtag of newData[col.field]) {
                    thisDataHashTags.add(hashtag);
                }
                set(thisDataHashTagsRef, [...thisDataHashTags]);
            }
        })
        newData.createdAt = Timestamp.now();
        newData.updatedAt = Timestamp.now();
        await setDoc(docRef, newData);
        // TODO: create a html version of the blog for SEO sake
        // use this package to convert md to html: https://www.npmjs.com/package/@wcj/markdown-to-html
        return newData;
    }
}